import Fuse from 'fuse.js';
import AllAirports from './AllAirports.js';

// Define the search function
export const searchAirport = async (searchTerm) => {
  try {
    // Fetch data from the JSON file
    const data = AllAirports;

    // Perform search
    if (!searchTerm) return data; // Return all data if searchTerm is empty

    const fuse = new Fuse(data, {
      keys: ['airport_name', 'city_name', 'IATA_code'], // Specify the fields to search
      threshold: 0.5 // Adjust the threshold for fuzzy search
    });

    const results = fuse.search(searchTerm).map(result => result.item);
    return results;

  } catch (error) {
    console.error('Error fetching data:', error);
    return []; // Return an empty array if there's an error
  }
};
